/**
 * @description Various modal names used in the enterprise modal manager.
 */
export const ENTERPRISE_MODAL_NAMES = {
  PROGRAM_ACCESS: 'PROGRAM_ACCESS',
  LOGIN: 'LOGIN',
  PRODUCT_DESCRIPTION_PAGE_REDIRECT: 'PRODUCT_DESCRIPTION_PAGE_REDIRECT',
  AUTOENROLLED_COURSES: 'AUTOENROLLED_COURSES',
  ADD_EMAIL: 'ADD_EMAIL',
  ENTERPRISE_TERMS_OF_USE: 'ENTERPRISE_TERMS_OF_USE',
  PROGRAM_JOIN_ERROR: 'PROGRAM_JOIN_ERROR',
  CHANGE_PREVIEW_PROGRAMS: 'CHANGE_PREVIEW_PROGRAMS',
} as const;

export enum TabName {
  Catalog = 'CATALOG',
  Recommendations = 'RECOMMENDATIONS',
  MyCourses = 'MY_COURSES',
  SkillSets = 'SKILLSETS',
  CareerAcademy = 'EXPLORE_CAREERS',
  MyLearning = 'MY_LEARNING',
}
